import React from "react";
import { useSelector } from "react-redux";

const ProfileUserImage = () => {
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  console.log(get_profile);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center rounded p-2 profile-img-container">
      <img src="/assets/user.png" alt="" className="my-2 profile-img" />
      <p className="my-2 profile-user-name" style={{color:"#ffd700"}}>{get_profile?.fullName}</p>
      <p className="my-2 profile-subs">{get_profile?.referId}</p>
      {/* <p className="my-2 profile-subs">Subscription level</p> */}
    </div>
  );
};

export default ProfileUserImage;
